module.exports = __webpack_public_path__ + "img/newS.d22ad847.png";